export class Participante {
  public id: number;
  public nombreCompleto = '';
  public numeroDocumento = '';
  // public tipoDocumento  = "";
  public tipoParticipante = 'T';
  public descTipoParticipante = 'T';
}
